const trimPart = value => String(value ?? '').trim()

const idString = value => trimPart(value?._id || value?.id || value)

const isInternalOriginalName = value => /^original$/i.test(trimPart(value))

/** Drop internal “Original (Unit)” wrapping. Chefs see pack UoM only. */
export const unwrapStockTakeOriginalUom = value => {
  const raw = trimPart(value)
  if (!raw) return 'Unit'
  const wrapped = /^original\s*\(\s*(.+?)\s*\)$/i.exec(raw)
  if (wrapped) return trimPart(wrapped[1]) || 'Unit'
  if (isInternalOriginalName(raw)) return 'Unit'
  return raw
}

/** Count-grid UoM dropdown: pack size + UoM, never “Original (Unit)”. */
export const formatStockTakeUomSelectBaseLabel = product => {
  const size = trimPart(product?.size)
  const uom = unwrapStockTakeOriginalUom(product?.UoM)
  if (size && uom) return `${size} · ${uom}`
  return uom
}

export const formatStockTakeUomOptionLabel = ({
  conversionName,
  conversionUnit,
  baseUom,
} = {}) => {
  const unit = unwrapStockTakeOriginalUom(conversionUnit || baseUom)
  const name = trimPart(conversionName)
  if (!name || isInternalOriginalName(name) || /^original\s*\(/i.test(name)) {
    return unit
  }
  if (unit && name.toLowerCase() !== unit.toLowerCase()) {
    return `${name} (${unit})`
  }
  return name || unit
}

export const stockTakeLineDisplayUom = (product, conversionOptions = []) => {
  const conversionId = idString(product?.conversionId)
  if (conversionId) {
    const selected = (
      Array.isArray(conversionOptions) ? conversionOptions : []
    ).find(option => idString(option?.value) === conversionId)
    if (selected) {
      return formatStockTakeUomOptionLabel({
        conversionName: selected.conversionName,
        conversionUnit: selected.conversionUnit || selected.label,
        baseUom: product?.UoM,
      })
    }
    return formatStockTakeUomOptionLabel({
      conversionName: product?.conversionName,
      conversionUnit: product?.conversionUnit,
      baseUom: product?.UoM,
    })
  }
  return unwrapStockTakeOriginalUom(product?.UoM)
}

/** Count mode: pack as text, including the conversion they are already on. */
export const formatStockTakeCountModePackText = (
  product,
  conversionOptions = [],
) => {
  const size = trimPart(product?.size)
  const uom = stockTakeLineDisplayUom(product, conversionOptions)
  if (size && uom) return `${size} · ${uom}`
  return uom
}

export const formatStockTakeLinePackLabel = (
  product,
  conversionOptions = [],
) => {
  const size = trimPart(product?.size)
  const uom = stockTakeLineDisplayUom(product, conversionOptions)
  const sku = trimPart(product?.sku)
  const price = Number(product?.price ?? product?.OMSPrice)
  const parts = []
  if (size) parts.push(size)
  if (uom) parts.push(uom)
  if (sku) parts.push(`SKU ${sku}`)
  if (Number.isFinite(price) && price > 0) {
    parts.push(`£${price.toFixed(2)}`)
  }
  return parts.join(' · ')
}
